// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ColorValue, ViewProps } from 'react-native';
import type { Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  axis: string;
  spacing: Double;
  alignment: string;
  colorScheme: string;
  dynamicTypeSize: string;
  controlSize: string;
  locale: string;
  tint?: ColorValue;
  isEnabled: string;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
let nativeComponentName = 'OneNativeHost';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeHost",
  validAttributes: {
    axis: true,
    spacing: true,
    alignment: true,
    colorScheme: true,
    dynamicTypeSize: true,
    controlSize: true,
    locale: true,
    tint: require('react-native/Libraries/Components/View/ReactNativeStyleAttributes').colorAttribute,
    isEnabled: true
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);